import { useParams } from 'react-router-dom';
import { useSupportStaffDetail } from '@/entities/support-staff';
import { WidgetsSupportStaffFormMain } from '@/widgets/support-staff-form';
import { extractErrorMessage } from '@/shared/api/errors';

export const PagesSupportStaffEditMain = () => {
  const { id = '' } = useParams<{ id: string }>();
  const query = useSupportStaffDetail(id);
  const errMsg = query.error ? extractErrorMessage(query.error) : undefined;
  return (
    <WidgetsSupportStaffFormMain
      mode="edit"
      staff={query.data}
      loading={query.isLoading}
      notFound={!query.isLoading && !query.data && !query.error}
      loadError={errMsg}
      onRetry={() => void query.refetch()}
    />
  );
};
